<template>
  <div
    class="relative flex flex-col gap-6"
    :class="{ 'md:grid md:grid-cols-3 md:gap-4 md:items-start': gridOnWide }"
  >
    <TypeLabelsSelect
      v-model="internalLabelIds"
      :name="$t('components.projects.labelsSelect.categories.name')"
      type="category"
      :multi="false"
      :skip-dependency-validation="skipDependencyValidation"
      :dedupe-labels-by-name="dedupeLabelsByName"
    />
    <TypeLabelsSelect
      v-model="internalLabelIds"
      :name="$t('components.projects.labelsSelect.themes.name')"
      type="theme"
      use-dependencies
      :skip-dependency-validation="skipDependencyValidation"
      :dedupe-labels-by-name="dedupeLabelsByName"
    />
    <TypeLabelsSelect
      v-model="internalLabelIds"
      :name="$t('components.projects.labelsSelect.tags.name')"
      type="tag"
      use-dependencies
      :skip-dependency-validation="skipDependencyValidation"
      :dedupe-labels-by-name="dedupeLabelsByName"
    />
  </div>
</template>

<script>
import { computed, reactive, toRefs } from 'vue';
import TypeLabelsSelect from '@/modules/projects/components/TypeLabelsSelect.vue';

export default {
  components: {
    TypeLabelsSelect,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    /** Sur md+, affiche Catégorie / Thème / Tag côte à côte (ex. filtres Gantt). */
    gridOnWide: {
      type: Boolean,
      default: false,
    },
    /** Voir `TypeLabelsSelect` — requis pour filtres admin (labels fusionnés multi-apps). */
    skipDependencyValidation: {
      type: Boolean,
      default: false,
    },
    dedupeLabelsByName: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const state = reactive({
      internalLabelIds: computed({
        get() {
          return props.modelValue;
        },
        set(value) {
          emit('update:modelValue', value);
        },
      }),
    });

    return {
      ...toRefs(state),
    };
  },
};
</script>

<style></style>
